import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

// components
import { SimplePanel } from '../../shared/_panel';
import { activateRep } from '../../../actions/repActions';


class Active extends React.Component {
  constructor(props) {
    super(props);

    this.state = { 
      id: this.props.params.id
    };
  }

  _activateRep() {
    const { repActivate } = this.props;

    repActivate(this.state.id);
  }

  componentDidMount() {
    this._activateRep();
  }

  render() {
    return (
      <div className='body__content body__content--center'>
        <SimplePanel header='Welcome'>
          <div className='session__logo' />
          <div className='session__message'>
            <p>Thank you for your response!</p>
          </div>
          <div className='session__form__password-reset'>
            <Link to='/reps/books'>Back to our website?</Link>
          </div>
        </SimplePanel>
      </div>
    );
  }
 
}

const mapDispatchToProps = (dispatch) => {
  return {
    repActivate: (id) => {
      dispatch(activateRep(id));
    }
  };
};


export default connect(null, mapDispatchToProps)(Active);



// WEBPACK FOOTER //
// ./app/components/reps/active/Index.jsx